module.exports = __webpack_public_path__ + "static/media/SupplyRoom.4a1bc400.webp";